import React from 'react';
import { Box } from '@mui/material';

/**
 * Shared print layout for branded documents (Ledger).
 * Renders the header + title, then arbitrary children content.
 * Intended for use inside pages as a print-only block, paired with window.print().
 */
const PrintPage = ({ title, children, footer = null, showSpacer = true }) => {
  return (
    <Box className="print-container print-quote" sx={{ display: 'none' }}>
      <style>{`
        @media print {
          .no-print,
          .no-print-quotes,
          .no-print-customers,
          .no-print-hr,
          .no-print-shipments,
          .no-print-dashboard,
          .no-print-procurement-po,
          .no-print-work-orders,
          .no-print-customer-detail,
          button,
          .MuiButton-root,
          .MuiIconButton-root,
          .MuiTabs-root,
          .MuiAppBar-root,
          .MuiDrawer-root,
          nav,
          .MuiModal-root,
          .MuiDialog-root,
          .MuiBackdrop-root {
            display: none !important;
          }
          .print-container {
            display: block !important;
          }
          /* Block flow so page breaks work; flex + min-height caused huge gaps on multi-page quotes */
          .print-quote-body {
            display: block !important;
            min-height: unset !important;
          }
          .print-quote-content {
            display: block !important;
          }
          .print-quote-spacer {
            display: none !important;
          }
          @page {
            size: letter;
            margin: 0.5in;
          }
          body {
            margin: 0;
            padding: 0;
            background: white;
          }
        }
      `}</style>

      <div className="print-quote-body">
        <div className="print-quote-content">
          <div className="print-quote-top-row">
            <div className="print-quote-logo" aria-hidden="true">
              <span style={{ fontSize: '28px', fontWeight: 700, color: '#004d40' }}>L</span>
            </div>
            <div className="print-quote-company-header">
              <div className="print-quote-company-name">Ledger</div>
              <div className="print-quote-company-address-line">Company address</div>
              <div className="print-quote-company-address-line">City, ST ZIP</div>
            </div>
          </div>

          <h1 className="print-quote-title">
            <em>{title}</em>
          </h1>

          {children}
        </div>

        {showSpacer && <div className="print-quote-spacer" aria-hidden="true" />}

        {footer}
      </div>
    </Box>
  );
};

export default PrintPage;

